<template>
<div>
  <div class="breadcrumbs-container">
    <nav class="breadcrumb is-medium" aria-label="breadcrumbs">
      <ul>
        <li><router-link :to="{name: 'Home'}">  
                        Home
                    </router-link></li>
        <li class="is-active">
        <router-link :to="{name: '$route.name'}">  
            {{ $route.name }}
        </router-link>                        
        </li>
      </ul>
    </nav>
  </div>
  <div>
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="false"></b-loading>
      <div class="container">
      <div class="columns is-centered">      
        <div class="column is-half">
        <h3 class="is-size-3">Photo</h3>
        <div class="m-tip">
        <b-icon
                pack="fas"
                icon="info"
                size="is-small">
            </b-icon>
          <em><strong>Add a cover image for your kitchen profile</strong></em>
          </div>
          <b-field class="image-uploader">
            <b-upload v-model="file" @input="onFileSelect"
                multiple
                accept="image/png,image/jpeg"
                drag-drop>
                <section class="section">
                    <div class="content has-text-centered">
                      <div v-if="user.image">
                        <figure class="center-avatar" :style="{ backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/' + user.image + '?alt=media)' }">
                        </figure>
                      </div>
                      <div v-else>
                          <b-icon
                              icon="upload"
                              size="is-large">
                          </b-icon>
                          <p>Drop your files here or click to upload</p>
                      </div>
                    </div>
                  </section>
              </b-upload>
          </b-field>        
          <div class="tags">
              <span
                  class="tag is-primary" v-if="file">
                  {{file[0].name}}
                  <button class="delete is-small"
                      type="button"
                      @click="deleteDropFile">
                  </button>
              </span>
          </div>
        </div>
        <div class="column is-half">
          <b-message v-if="!auth.emailVerified" type="is-danger" has-icon>
            <h3 class="is-size-3 mb-20">Email needs verification</h3>
              <p>You haven't confirmed your email address yet!</p>
              <a class="button is-danger is-pulled-right mt-20" @click="sendVerificationEmail">Re-send confirmation</a>
          </b-message>
          <!--
          <b-message v-else-if="!subscription.isValid" type="is-danger" has-icon>
            <h3 class="is-size-3 mb-20">You're Not Subscribed!</h3>
              <p>Subscribe to MyMeatloaf for unlimited access</p>
              <a class="button is-danger is-pulled-right mt-20" href="/checkout">Subscribe</a>
          </b-message>
          -->
          <b-message v-else type="is-success" has-icon>
            <h3 class="is-size-3 mb-20">You're Subscribed!</h3>
              Start <router-link :to="{name: 'Create Recipe'}">creating recipes</router-link> now!
          </b-message>
          
        </div>
      </div>
      <div class="columns">
        <div class="column is-half">    
        <h3 class="is-size-3 mb-20">Profile Information</h3>      
          <b-field label="Kitchen Name" label-position="inside">
              <b-input v-model="user.kitchen_name"                               
              ></b-input>
          </b-field>
          <b-field label="Web/Blog Adress" label-position="inside">
              <b-input v-model="user.website"                               
              ></b-input>
          </b-field>
          <b-field label="Description" label-position="inside">
              <b-input v-model="user.description" maxlength="600" type="textarea"></b-input>
          </b-field>
          <div>
              <button class="button secondary-btn is-fullwidth" @click="updateInfo">Save Changes</button>
          </div>
        </div>
 
        <div class="column is-half">
          <h3 class="is-size-3 mb-20">Account Information</h3>
            <div v-if="auth.providerData[0].providerId == 'password'">      
              <b-field label="Email"
              label-position="inside"
                  :type="labelEmailType"
                  :message="labelEmailMessage">
                  <b-input type="email"
                      v-model="account.email">
                  </b-input>
              </b-field>
              <b-collapse :open="false" aria-id="contentIdForA11y1">
                <button
                  class="button secondary-btn is-fullwidth"
                  slot="trigger"
                  aria-controls="contentIdForA11y1">Change Email</button>
                <div class="notification is-danger">
                  <div class="content">
                                  Are You Sure? NOTE: Once you change your email, you will receive a confirmation email and have to re-verify it.
                  <button class="button secondary-btn is-fullwidth" @click="updateEmail">Yes, change my email</button>

                  </div>
                </div>
              </b-collapse>    
              <div style="margin-top:53px;">
                <b-field label="Password"
                label-position="inside"
                    :type="labelPasswordType"
                    :message="labelPasswordMessage">
                    <b-input v-model="account.password" type="password"></b-input>
                </b-field>
                <b-field label="Confirm Password"
                label-position="inside">
                    <b-input v-model="account.checkPassword" type="password"></b-input>
                </b-field> 
                <b-collapse :open="false" aria-id="contentIdForA11y1">
                <button
                  class="button secondary-btn is-fullwidth"
                  slot="trigger"
                  aria-controls="contentIdForA11y1">Change Password</button>
                <div class="notification is-danger">
                  <div class="content">
                                  Are You sure you want to change your password?
                  <button class="button secondary-btn is-fullwidth"  @click="updatePassword">Yes, change my password</button>

                  </div>
                </div>
                </b-collapse> 
              </div>                 
            </div>  
            <div v-else>
            <article class="media">
               <figure class="media-left">
               <p class="image is-64x64">
                <img class="is-rounded" alt="Google Logo" src="../assets/google-logo.png">
              </p>
                </figure>
              <div class="media-content">
                <div class="content">
                  <p class="is-size-5">
                    <strong>{{auth.email}}</strong><br />
                    <small>{{auth.providerData[0].providerId}}</small>
                  </p>
                </div>
                <nav class="level is-mobile">
                  <div class="level-left">
                    <a class="level-item">
                      <span class="icon is-small"><i class="fas fa-reply"></i></span>
                    </a>
                    <a class="level-item">
                      <span class="icon is-small"><i class="fas fa-retweet"></i></span>
                    </a>
                    <a class="level-item">
                      <span class="icon is-small"><i class="fas fa-heart"></i></span>
                    </a>
                  </div>
                </nav>
              </div>
            </article> 
            </div>              
      </div>
  </div>
  </div>
  </div>
</div>
</template>

<script>
import firebase from '@/firebase';
import db from '@/db';
var uuidv4 = require("uuid/v4");

export default {
  name: "user",
  props: {
    msg: String
  },
  data(){
    return {
        user: {
          kitchen_name:null,
          website:null,
          description:null,
          image:null          
        },
        old_kitchen_name:null,
        account:{
            email: '',
            name: '',
            password: '',
            checkPassword:''
        },
        subscription:{
          isValid:false,          
        },
        labelEmailType: '',
        labelPasswordType: '',
        labelEmailMessage: '',
        labelPasswordMessage: [],
        PasswordRules: [
          { message:'One lowercase letter required.', regex:/[a-z]+/ },
          { message:"One uppercase letter required.",  regex:/[A-Z]+/ },
          { message:"8 characters minimum.", regex:/.{8,}/ },
          { message:"One number required.", regex:/[0-9]+/ }
        ],
        isValid: false,
        file: null,
        currentImage: null,
        auth: firebase.auth().currentUser,
        isLoading: false,
        isFullPage: true        
    }
  },
  async mounted() {
    const that = this;
    db.collection('users').doc(this.auth.uid)
      .get().then(docSnapshot => {
          if (!docSnapshot.exists) return;
          this.user = docSnapshot.data()
          this.account.email = this.auth.email;
          this.old_kitchen_name = this.user.kitchen_name;
      });
    db.collection("subscriptions").where("user_id", "==", this.auth.uid)
    .get().then(querySnapshot => {
        querySnapshot.forEach(function(doc) {
          if (!doc.exists) return;
            that.subscription.isValid = true
        });
    })
    .catch(function(error) {
        console.log("Error getting documents: ", error);
    });
  },
  methods:{
      updateInfo(){
        const vm = this;
        this.isLoading = true;
        if(this.user.kitchen_name) {
          let new_kitchen_name = this.user.kitchen_name;
          let old_kitchen_name = this.old_kitchen_name;
          this.user.kitchen_name = this.user.kitchen_name.trim();
          db.collection('users').doc(this.auth.uid).update(this.user); 
          if(old_kitchen_name != new_kitchen_name) {
            db.collection("meals")
            .where("kitchen_name", "==", old_kitchen_name)
            .get()
            .then(function(querySnapshot) {
              querySnapshot.forEach(function(doc) {  
                console.log(old_kitchen_name);              
                doc.ref.update({ ["kitchen_name"]: new_kitchen_name });
              });
            })
            .then(function() {
              vm.old_kitchen_name = new_kitchen_name;
            });
            db.collection("recipes")
            .where("kitchen_name", "==", old_kitchen_name)
            .get()
            .then(function(querySnapshot) {
              querySnapshot.forEach(function(doc) {  
                console.log(old_kitchen_name);              
                doc.ref.update({ ["kitchen_name"]: new_kitchen_name });
              });
            })
            .then(function() {
              vm.old_kitchen_name = new_kitchen_name;
            });
            db.collection("menus")
            .where("kitchen_name", "==", old_kitchen_name)
            .get()
            .then(function(querySnapshot) {
              querySnapshot.forEach(function(doc) {  
                console.log(old_kitchen_name);              
                doc.ref.update({ ["kitchen_name"]: new_kitchen_name });
              });
            })
            .then(function() {
              vm.old_kitchen_name = new_kitchen_name;
            });
          }

          vm.$buefy.toast.open({
            duration: 3000,
            message: 'Your profile has been updated.',
            position: 'is-bottom',
            type: 'is-success'
          });
          this.isLoading = false;
        }
        else {
          vm.$buefy.toast.open({
            duration: 3000,
            message: 'Your Kitchen Name cannot be empty.',
            position: 'is-bottom',
            type: 'is-danger'
          });
          this.isLoading = false;
        }
      },
      updateEmail(){
        this.isLoading = true;
        const vm = this;
        this.validateEmail().then((isValid) => {
          console.log(isValid)
          if(!isValid) {
              console.log('nope')
              this.isLoading = false;
          }
          else {
              this.auth.updateEmail(this.account.email).then(function() {
                console.log("update successful")
                firebase.auth().currentUser.sendEmailVerification().then(function() {
                    vm.$buefy.toast.open({
                        duration: 3000,
                        message: 'Your email has been successfuly changed. You should receive a verification email shortly.',
                        position: 'is-bottom',
                        type: 'is-success'
                    })
                    this.isLoading = false;
                  }).catch(function(error) {
                    console.log(error);
                    this.isLoading = false;
                  });
              }).catch(function(error) {
                console.log(error);
                this.isLoading = false;
              });
          }
        })
      },
      updatePassword(){
        this.isLoading = true;
        const vm = this;
        this.validatePassword().then((isValid) => {
          console.log(isValid)
          if(!isValid) {
              console.log('nope');
              this.isLoading = false;
          }
          else {
              this.auth.updatePassword(this.account.password).then(function() {
              vm.$buefy.toast.open({
                  duration: 3000,
                  message: 'Your password has been successfuly updated.',
                  position: 'is-bottom',
                  type: 'is-success'
              });
              this.isLoading = false;
            }).catch(function(error) {
              console.log(error);
              this.isLoading = false;
            });
          }
        })
      },
      async validateEmail() {
            this.labelEmailType = '';
            this.labelEmailMessage = '';
            this.isValid = true;
            if(!this.validEmail(this.account.email)) {
                this.labelEmailType = 'is-danger';
                this.labelEmailMessage = 'Valid email required';
                this.isValid = false;
            }
            return this.isValid;                
        },
        async validatePassword() {
            this.labelPasswordMessage=[];
            this.labelPasswordType='';
            this.isValid = true;
            for (let condition of this.PasswordRules) {
                if (!condition.regex.test(this.account.password)) {
                    this.labelPasswordMessage.push(condition.message)
                    this.labelPasswordType = "is-danger";
                    this.isValid = false;
                }
            }
            if(this.account.password !== this.account.checkPassword) {
                this.labelPasswordMessage.push('Passwords do not match')
                this.isValid = false;
            }
            return this.isValid;                
        },
      deleteDropFile() {
        this.file = null
        this.user.image = null;
      },
      onFileSelect(){
      this.isLoading = true;
      const file = this.file[0];
      let re = /(?:\.([^.]+))?$/;
          let ext = re.exec(file.name)[1];   // "txt"
          let fileName = uuidv4() + "." + ext;
      const self = this;
      if (typeof FileReader === 'function') {
        var reader = new FileReader();
        reader.onloadend = function (evt) {
          var blob = new Blob([evt.target.result], { type: "image/jpeg" });
          firebase.storage().ref(fileName).put(blob)
          .then((snapshot) => {
              return snapshot.ref.getDownloadURL(); // Will return a promise with the download link
          })
          .then((downloadURL) => {
              console.log(`Successfully uploaded file and got download link - ${downloadURL}`);
              return self.setCurrentImage(fileName);
          })
        }
        reader.onerror = function (e) {
            console.log("Failed file read: " + e.toString());
            this.isLoading = false;
        };
        reader.readAsArrayBuffer(file);        
      } else {
        alert('Sorry, FileReader API not supported');
        this.isLoading = false;
      }        
      },
      setCurrentImage(fileName) {
            this.user.image = fileName;
            this.isLoading = false;
      },
      validEmail:function(email) {
          var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return re.test(email);
      },
      sendVerificationEmail() {
        const vm = this;
        firebase.auth().currentUser.sendEmailVerification().then(function() {
          vm.$buefy.toast.open({
              duration: 3000,
              message: 'Confirmation email sent. You should receive a verification email shortly.',
              position: 'is-bottom',
              type: 'is-success'
          })
        }).catch(function(error) {
          console.log(error)
        });
      }
  },
  
};
</script>
